import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-tags-field',
  template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <ng-select [items]="[]"
           [addTag]="true"
           [multiple]="true"
           [selectOnTab]="true"
           [isOpen]="false"
           [formControl]="formControl"
           [classList]="'bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 mb-3'"
           >
    </ng-select>
  `,
})
export class TagsType extends FieldType<FieldTypeConfig> {
    addTag(name: string) {
        return { name, tag: true };
    }
}
